<template>
    <span
        class="text-danger float-left mr-1"
        v-if="convenio.idSituacaoConvenio != 9"
    >
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Excluir Aplicação de Recurso"
            @click.stop="confirmarExcluir(aplicacaoRecurso.idAplicacaoRecurso)"
        ></i>
    </span>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'

export default {
    props: {
        convenio: Object,
        aplicacaoRecurso: Object, 
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir(id){
            this.$swal({
                title: 'Excluir',
                html: 'Deseja Excluir a Aplicação de Recurso ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir(id)
                }
            })
        },

        excluir(id){
            this.$store.dispatch('addRequest')
            ConveniosServicos.excluirAplicacaoRecurso(id)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('atualizarListaAplicacaoRecurso')
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    }
}
</script>
